import { getFormData } from 'platform/forms-system/src/js/state/selectors';
import { formatFullName } from 'platform/shared/health-apps';

/**
 * @param {Object} state - Redux state
 * @returns {string} the formatted Veteran full name for the PDF download
 */
export const selectPdfFullName = state =>
  formatFullName(
    getFormData(state)?.['view:veteranInformation']?.veteranFullName,
  );
